import { render, staticRenderFns } from "./ConfigureBrandFilterPopup.vue?vue&type=template&id=19e56254&scoped=true&"
import script from "./ConfigureBrandFilterPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfigureBrandFilterPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigureBrandFilterPopup.vue?vue&type=style&index=0&id=19e56254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e56254",
  null
  
)

export default component.exports